import React from "react"
import final1 from "../assets/images/final4.jpg"
import final2 from "../assets/images/DSC_2470.JPG"
import final3 from "../assets/images/AZ8_7174.jpg"
import final4 from "../assets/images/AZ8_7185.jpg"
import final5 from "../assets/images/AZ8_7216.jpg"
import final6 from "../assets/images/AZ8_7106.jpg"
import final7 from "../assets/images/AZ8_6777.jpg"
import { motion } from "framer-motion"

const ServiceCard = ({ icon, title, description }) => (
  <div className="bg-white p-4 md:p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
    <div className="flex justify-center mb-3 md:mb-4">{icon}</div>
    <h3 className="text-lg md:text-xl font-semibold mb-2 text-gray-800 text-center">{title}</h3>
    <p className="text-sm md:text-base text-gray-600 text-center">{description}</p>
  </div>
)

const Manufacturing = () => {
  const services = [
    {
      icon: (
        <svg
          className="w-10 h-10 md:w-12 md:h-12 text-gray-700"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M3 12l9-9 9 9M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ),
      title: "Truss Systems",
      description: "Engineering robust and efficient structural frameworks tailored for diverse construction needs.",
    },
    {
      icon: (
        <svg
          className="w-10 h-10 md:w-12 md:h-12 text-gray-700"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M9 3v18m0-18h12M9 21h12" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ),
      title: "Technology",
      description: "Empowering industries with state-of-the-art solutions that redefine productivity and innovation.",
    },
    {
      icon: (
        <svg
          className="w-10 h-10 md:w-12 md:h-12 text-gray-700"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M4 6h16M4 12h16m-7 6h7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ),
      title: "Materials",
      description: "Delivering premium-grade materials designed to meet the toughest performance standards.",
    },
    {
      icon: (
        <svg
          className="w-10 h-10 md:w-12 md:h-12 text-gray-700"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path
            d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      title: "Advanced Manufacturing",
      description: "Pioneering the future of production with precision engineering and innovative methods.",
    },
  ]

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Section with Background Video */}
      <div className="relative h-[500px] flex items-center justify-center">
      <div
      className="absolute top-0 left-0 w-full h-full bg-cover bg-center z-0"
      style={{ backgroundImage: "url('https://thomasdigital.com/wp-content/uploads/2021/04/15.jpg')" }}
    ></div>


        <div className="relative z-10 text-center text-white p-8">
          <h1 className="text-4xl md:text-6xl font-bold mb-4 leading-tight">
            Paths to Precision Crafting Excellence
          </h1>
         
        </div>
      </div>

      {/* Services Section */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <ServiceCard key={index} icon={service.icon} title={service.title} description={service.description} />
          ))}
        </div>
      </div>
      <div className="container mx-auto px-4 py-16 max-w-6xl">
        {/* Header Section */}
        <motion.div className="mb-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight">
            Bhagwati Products Limited:
            <br />
            Shaping the Future of Electronics in India
          </h2>

          <div className="space-y-4 text-base md:text-lg text-gray-700">
            <p>
              Founded in 2002, Bhagwati Products Limited has established itself as a leader in India's electronics and
              telecommunication industry. With a legacy of innovation and excellence, we specialize in manufacturing and
              assembling mobile phones, LED TVs, batteries, chargers, and other consumer electronics. To date, we have
              proudly produced over 100 million phones, 15 million Tablets- PCs and 15 million TVs, reflecting our
              unwavering commitment to technological advancement and quality.
            </p>
            <p>
              Our four state-of-the-art facilities in Greater Noida, Bhiwadi, Hyderabad, and Rudrapur are strategically
              designed to deliver superior performance. Equipped with the latest technologies and powered by a highly
              skilled workforce, these facilities ensure our products consistently meet the highest quality standards.
            </p>
            <p>
              At Bhagwati Products Ltd., we aim to create lasting value for our clients by delivering technologically
              advanced, reliable, and competitively priced products that cater to diverse consumer needs. Guided by our
              vision to become India's most preferred electronics partner, we continue to redefine the industry with
              innovation and excellence.
            </p>
          </div>
        </motion.div>

        {/* Grid Layout */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 auto-rows-min">
          {/* Left Column */}
          <motion.div className="h-full">
            <div className="h-[600px] md:h-full relative">
              <img
                src={final2 || "/placeholder.svg"}
                alt="Manufacturing Facility"
                className="absolute inset-0 w-full h-full object-cover rounded-lg"
              />
            </div>
          </motion.div>

          {/* Middle Column */}
          <div className="grid gap-6">
            <motion.div className="h-48 md:h-64">
              <img
                src={final7 || "/placeholder.svg"}
                alt="Advanced Manufacturing Systems"
                className="w-full h-full object-cover rounded-lg"
              />
            </motion.div>
            <motion.div className="h-48 md:h-64">
              <img
                src={final4 || "/placeholder.svg"}
                alt="Automation Technology"
                className="w-full h-full object-cover rounded-lg"
              />
            </motion.div>
            <motion.div className="h-48 md:h-64">
              <img
                src={final5 || "/placeholder.svg"}
                alt="State-of-the-Art Equipment"
                className="w-full h-full object-cover rounded-lg"
              />
            </motion.div>
          </div>

          {/* Right Column */}
          <div className="grid gap-6">
            <motion.div className="h-48 md:h-64">
              <img
                src={final1 || "/placeholder.svg"}
                alt="Smart Manufacturing Equipment"
                className="w-full h-full object-cover rounded-lg"
              />
            </motion.div>
            <motion.div className="h-48 md:h-64">
              <img
                src={final6 || "/placeholder.svg"}
                alt="Precision Manufacturing Tools"
                className="w-full h-full object-cover rounded-lg"
              />
            </motion.div>
            <motion.div className="h-48 md:h-64">
              <img
                src={final3 || "/placeholder.svg"}
                alt="High-Tech Assembly Line"
                className="w-full h-full object-cover rounded-lg"
              />
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Manufacturing

